import axios from 'axios';

class GitHubService {
  constructor() {
    this.token = import.meta.env.VITE_GITHUB_TOKEN;
    this.owner = import.meta.env.VITE_GITHUB_OWNER;
    this.repo = import.meta.env.VITE_GITHUB_REPO || 'crm-audit-logs';
    this.apiUrl = 'https://api.github.com';
  }

  async createCommit(type, message) {
    try {
      const timestamp = new Date().toISOString();
      const content = {
        timestamp,
        type,
        message,
        user: 'system'
      };

      const encodedContent = btoa(JSON.stringify(content, null, 2));
      const path = `logs/${type}/${timestamp.split('T')[0]}/${Date.now()}.json`;

      const response = await axios.put(`${this.apiUrl}/repos/${this.owner}/${this.repo}/contents/${path}`, {
        message: `CRM Log: ${message}`,
        content: encodedContent,
        branch: 'main'
      }, {
        headers: {
          'Authorization': `token ${this.token}`,
          'Content-Type': 'application/json'
        }
      });

      return response.data;
    } catch (error) {
      console.error('GitHub commit error:', error.message);
      // Don't throw error to avoid breaking CRM functionality
      return null;
    }
  }

  async getLogs(type, date = null) {
    try {
      const path = date ? `logs/${type}/${date}` : `logs/${type}`;
      const response = await axios.get(`${this.apiUrl}/repos/${this.owner}/${this.repo}/contents/${path}`, {
        headers: {
          'Authorization': `token ${this.token}`,
          'Accept': 'application/vnd.github.v3+json'
        }
      });

      return response.data;
    } catch (error) {
      console.error('GitHub logs error:', error.message);
      return [];
    }
  }

  async createRepository() {
    try {
      const response = await axios.post(`${this.apiUrl}/user/repos`, {
        name: this.repo,
        description: 'CRM Audit Logs Repository',
        private: false,
        auto_init: true
      }, {
        headers: {
          'Authorization': `token ${this.token}`,
          'Content-Type': 'application/json'
        }
      });

      return response.data;
    } catch (error) {
      console.error('GitHub repo creation error:', error.message);
      return null;
    }
  }
}

export const githubService = new GitHubService();